<mat-toolbar class="subtitulo">Situação de Vulnerabilidade</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        
        <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlex= "95%" fxFlexOffset="20px" >
                  <input matInput maxlength="200"  name="descricao" 
                         placeholder="Descrição:" 
                         [(ngModel)]="situacao.descricao" 
                         required>
             </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-checkbox name="sigiloso" 
                          fxFlexOffset="20px"
                          [(ngModel)]="situacao.sigiloso">Indicar se é sigilosa, podendo ser apresentada somente nos módulos do Psicossocial
            </mat-checkbox>
        </div>


      <!-- BOTOES -->
      <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
                name="botaoConfirmar"
                fxFlex="20%"
                color="primary"
                [disabled]="formCadastro.invalid"
                (click)="cadastrar()"> Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
                name="botaoConfirmar"
                fxFlex="20%"
                color="primary"
                [disabled]="formCadastro.invalid"
                (click)="atualizar()">
                Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" 
                mat-raised-button 
                fxFlex="20%" 
                (click)="limpar()">
                Limpar
        </button>
        <button 
                mat-raised-button 
                fxFlex="20%" 
                (click)="cancelar()">
                Cancelar
        </button>
       </div>
    </form>


</div>
